import React from 'react';
import * as ReactDOM from 'react-dom';
import { compose, contains, append, reduce } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

import { Button, Link, Image, RichText } from '@synergycms_core/components/generic';
import { CSSTransition } from 'react-transition-group';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './footer.js';
import { connect } from 'react-redux';
import ConditionsModal from '../CustomerForm/ConditionsModal';

const FooterLinks = compose(withThemeJSS({ styleFile, displayName: 'Footer' }))(props => {
    const { classes } = props.theme.styles;
    const { list } = props;
    return (
      <div className={classes.footerInfo}>
          {list.map((val, index) => (
            <div key={index} className={classes.footerItemGroup}>
                {props.theme.isDesk() && index > 0 && (
                  <span className={classes.linkSeparator}></span>
                )}
                <ConditionsModal
                  modalTitle={val.name}
                  modalText={val.text}
                  ucFirst={true}
                  isModalFooter={true}
                />
            </div>
          ))}
      </div>
    );
});
class Footer extends React.Component {
    static displayName = 'Footer';

    constructor(props) {
        super(props);
        this.state = {
            seeLinks: false
        };
    };

    isMobile = () => {
        return this.props.theme.deviceType !== 'DESK';
    };

    toggleLinks = e => {
        e.preventDefault();
        const willOpen = !this.state.seeLinks;
        this.setState(state => ({
            seeLinks: !state.seeLinks
        }));
        if (willOpen) {
            setTimeout(() => {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            }, 300);
        }
    };

    componentDidMount() {
        this.element = ReactDOM.findDOMNode(this);

        if (this.isMobile()) {
            document.addEventListener('click', this.propagateCloseDropDown);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.propagateCloseDropDown);
    }

    propagateCloseDropDown = e => {
        if (!e || (this.element && this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
            this.setState(state => ({
                seeLinks: false
            }));
        }
    };
    render() {
        const { theme, content, config } = this.props;
        const { classes } = theme.styles;
        const { stepCode, group } = config;
        const arrayLinks = ['AVISO_LEGAL', 'POLITICA_PRIVACIDAD', 'PROTECCION_DATOS', 'COOKIES', 'POLITICA_COOKIES', 'TERMINOS_DE_USO', 'CONDICIONES_GENERALES'];
        const objectList = reduce((acc, code) => {
            let link = content.getLinks(code);
            return (link && append({ name: '_%' + code + '%_', "link": link, "text": '_%' + code + '_TEXT%_' }, acc)) || acc;
        }, [], arrayLinks);
        return (
            (!contains(stepCode, ['cancelation']) && objectList.length >= 1 && (
                <div className={classes.footer}>
                    <div className={classes.footerLeftLogo}>
                        {contains(group, ['eurostarshotels', 'tandemapartments', 'eurostarshotelcompany', 'eurostarshotelsunificado']) ?
                            <Image innerStyle={classes.logoElement} svg={'hotusaGroup'} /> :
                            <Image innerStyle={classes.logoElement} svg={'keytel'} />
                        }
                    </div>
                    <div className={classes.footerContent}>
                        {this.isMobile() &&
                            <Button
                                innerStyle={classes.footerContentTitleButton}
                                onClick={this.toggleLinks}
                                richText={{
                                    text: '_%legal%_',
                                    translate: true,
                                    ucFirst: true,
                                    icon: {
                                        unicodeContent: this.state.seeLinks ? 'e0b5' : 'e0b2',
                                        innerStyle: classes.footerContentTitleIcon
                                    }
                                }} />
                        }
                        <CSSTransition
                            in={this.state.seeLinks || !this.isMobile()}
                            timeout={300}
                            mountOnEnter
                            unmountOnExit
                            classNames={{
                                enter: classes.seeLinksEnter,
                                enterActive: classes.seeLinksEnterActive,
                                exit: classes.seeLinksLeave,
                                exitActive: classes.seeLinksLeaveActive
                            }}>
                            <FooterLinks list={objectList} />
                        </CSSTransition>
                    </div>
                    <div className={classes.footerRightLogo}>
                        <div>
                            <RichText
                              innerStyle={classes.safeBuy}
                              ucFirst={true}
                              text={'© '}
                            />
                            <RichText
                              innerStyle={[classes.safeBuy, this.isMobile() ? classes.safeBuyBreak : '']}
                              ucFirst={true}
                              translate={true}
                              text={'_%eurostars_hotel_company_year%_'}
                            />
                        </div>
                        <RichText
                            innerStyle={classes.safeBuySmall}
                            translate={true}
                            ucFirst={true}
                            text={'_%todos los derechos reservados%_'}
                        />
                    </div>
                </div>
            )) || null
        );
    }
}
const mapStateToProps = store => {
    return {
        stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
        group: store.get("group", false)
    };
};
export default compose(
    connect(mapStateToProps),
    PropertyManager([
        'stepCode',
        'group'
    ]),
    withThemeJSS({ styleFile, link: true }),
    withContent('links')
)(Footer);